import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

export async function getEstados({ commit, state }) {
    await $http.get('controles/8')
        .then((response) => {
            commit('cargarEstados', response.data)
        })
        .catch((error) => {

        })
}

export async function getExisteNoExiste({ commit, state }) {
    await $http.get('controles/15')
        .then((response) => {
            commit('CargarExisteNoExiste', response.data)
        })
        .catch((error) => {

        })

}

export async function guardaProducto({ commit, state }) {
    await $http.post('adm_productos/crear', state.selectedProduct)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            state.error = false
            commit('guardaProducto', state);
            state.selectedProduct.Idproducto = response.data.Idproducto;
            this.getProducto(state.selectedProduct.Idproducto);
        })
        .catch((error) => {

            //commit('productError', error.message)
        })
}

export async function actualizaProducto({ commit, state, rootState }, id) {
    await $http.put(`adm_productos/editar/${id}`, state.selectedProduct)
        .then((response) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
            state.error = false;
            this.getProducto(state.selectedProduct.Idproducto);
        })
        .catch((error) => {
            //commit('productError', error.message)
        })
}

export async function getProductosContra({ commit, state, dispatch, rootState }) {

    commit('asignaEmpresaYusuario',rootState.empresa);
    let requestParameters = { params: state.filtro }
    await $http.get('adm_productos', requestParameters)
    .then((response) => {
        let pros = response.data;
        commit('setProductos', pros);
    })
    .catch((error) => {

        //commit('productError', error.message)
    });
}

export async function getProductosEmpresa({ commit, state }, requestParameters = { params: state.filtro }) {
    await $http.get('productos', requestParameters)
        .then((response) => {

            commit('setProductos', response.data)
        })
        .catch((error) => {

            //commit('productError', error.message)
        })
}
export async function getEmpresaFiltro({ commit, state }, query) {

    await $http.get('/empresas/lista', { params: { nombre: query } })
        .then((response) => {

            commit('setListaEmpresa', response.data)
            state.error = false
        })
        .catch((error) => {
            commit('mensajeError', error.message)
        })
}
export async function getAreasFiltro({ commit, state }, query) {
    await $http.get(`empresas/areas/${state.filtro.empresa}`, { params: { nombre: query } })
        .then((response) => {

            commit('setListaAreas', response.data)
            state.error = false
        })
        .catch((error) => {
            commit('mensajeError', error.message)
        })
}
export async function getBasesFiltro({ commit, state }, query) {
    await $http.get(`empresas/bases/${state.filtro.empresa}`, { params: { nombre: query } })
        .then((response) => {
            commit('setListaBases', response.data)
            state.error = false
        })
        .catch((error) => {
            commit('mensajeError', error.message)
        })
}
export async function getCamposPersonalizados({ commit, state }) {
    await $http.get(`adm_productos/campos_personalizados/${state.filtro.empresa}`)
        .then((response) => {
            commit('setListaCampos', response.data)
            state.error = false
        })
        .catch((error) => {
            commit('mensajeError', error.message)
        })
}

export async function descargarAdjunto({ commit, state }, id) {
    await $http.get(`adm_productos/adjuntos/download/${id}`)
        .then((response) => {           
            state.error = false
        })
        .catch((error) => {
            commit('productError', error.message)
        })
}

export async function getProductoTarjeta({ commit, state }, id) {
    await $http.get(`adm_productos/${id}`)
        .then((response) => {

            commit('setProducto', response.data)
        })
        .catch((error) => {
            commit('productError', error.message)
        })
}

export function setPagePagination({ commit, dispatch, state }, page) {
    commit('setPage', parseInt(page))
        //  if (state.esAdmin) {
    dispatch('getProductos')
        /*  }
         if (state.esEmpresa) {
             dispatch('getProductosEmpresa')
         } */

}

/**
 * Método para obtener los campos personalizados en la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getEmpresasPersonalizados({ commit, state, rootState }) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == "") {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    var IdProducto = parseInt(producto);

    await $http.post(`adm_productos/campos_personalizados/${IdProducto}`)
        .then((response) => {
            commit('setCamposPersonalizados', response.data.campos)

        })
        .catch((error) => {

        })
}

/**
 * Método para obtener las bases y áreas de la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getBasesAreasEmpresa({ commit, state, rootState }) {

    var producto = rootState.productos.selectedProduct.id;
    if (producto == "") {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    var IdProducto = parseInt(producto);

    await $http.get(`empresas/getBasesAreasEmpresas/${IdProducto}`)
        .then((response) => {

            commit('setBasesAreas', response.data.data)

        })
        .catch((error) => {

        })
}

/**
 * Método para obtener la información de CAS de la pantalla de empresas.
 *
 * @param {*} param0
 */
export async function getListadoCas({ commit, state, rootState }, id) {

    /* var producto = rootState.productos.selectedProduct.id;
    if(producto == ""){
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    var IdProducto = parseInt(producto); */

    await $http.get(`adm_productos/nocas/ver/${id}`)
        .then((response) => {
            commit('setCasEmpresa', response.data)
        })
        .catch((error) => {

        })
}

export async function guardaContratista({ commit, state, rootState }, data) {

    var empresa = rootState.empresa.selectedEmpresa.id;
    var usuario = rootState.empresa.edicionUsuario.id;

    await $http.post(`productos/contratistas/${usuario}`, { id_producto: data.id, id_empresa: empresa, tipo: data.tipo, estado: data.valor,  })
    .then((response) => {

        ;

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            })
    })
    .catch((error) => {

    });
}
